export const windowReady = (callback) => {
  if (document.readyState === "complete") {
    callback();
  } else {
    window.addEventListener("load", callback);
  }
};

export const delay = (callback) => setTimeout(callback, 250);
